import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import filter from './modules/filter'
import locale from './modules/locale'
import navigation from './modules/navigation'
import timelapse from './modules/timelapse'
import video from './modules/video'
import onboarding from './modules/onboarding'
import patient from './modules/patient'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        common,
        filter,
        locale,
        timelapse,
        video,
        navigation,
        onboarding,
        patient
    },
    state: () => ({}),
    getters: {},
    mutations: {},
    actions: {}
})
